<template>
    <!-- 读后感受 -->
    <div class="feel-box">
        <!-- 遮罩 -->
        <div v-if="needShowDialog" @click="closeDialog" class="shadow"></div>
        <div :class="['feel-page', needShowDialog ? 'dialog' : 'page']">
            <div class="feel-top">
                <img class="icon" src="https://g.gsxcdn.com/2274275627_pq1vo0kq.png" alt="">
                <div class="title">读后感受</div>
                <div class="desc">记录学习后的感受噢</div>
            </div>
            <!-- 未选择感受 -->
            <div class="unselect-box" v-if="!isChoosed">
                <div
                    class="item"
                    v-for="item in feelData"
                    :key="item.id"
                    @click="handleFeel(item)"
                >
                    <img class="emotion-img" v-show="item.choosing" :src="item.choosedEmotion" alt="">
                    <img class="emotion-img" v-show="!item.choosing" :src="item.emotion" alt="">
                    <div class="emotion-desc">{{item.content}}</div>
                </div>
            </div>
            <!-- 已选择感受 -->
            <div class="select-box" v-if="isChoosed">
                <img class="emotion-img" :src="choosedFeelRes.emotion" alt="">
                <div class="right-content">
                    <img class="icon-top" src="https://g.gsxcdn.com/2274291460_ogl0h1za.png" alt="">
                    <div :class="['emotion-content', choosedFeelRes.className]">
                        {{choosedFeelRes.content}}
                    </div>
                    <div class="date">{{pageData.feedbackInfo.recordTime}}记录</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="js">
import {Options, Vue} from 'vue-class-component';
import {readFeedback} from '@/api/api';

// 感受的对应关系:1-愉快 2-惊喜 3-感动
const FEEL_MAP = [
    {
        id: 1,
        content: '愉快',
        emotion: 'https://g.gsxcdn.com/2274269953_19vyiq86.png',
        choosedEmotion: 'https://i.gsxcdn.com/2392987462_gtfqbkc3.png',
        className: 'happy',
        choosing: false
    },
    {
        id: 2,
        content: '惊喜',
        emotion: 'https://g.gsxcdn.com/2274269951_hk8a05c2.png',
        choosedEmotion: 'https://i.gsxcdn.com/2392918768_cvk14v81.png',
        className: 'amazing',
        choosing: false
    },
    {
        id: 3,
        content: '感动',
        emotion: 'https://g.gsxcdn.com/2383125195_dr474r87.png',
        choosedEmotion: 'https://i.gsxcdn.com/2392918761_dq0f14jf.png',
        className: 'sad',
        choosing: false
    },
];

@Options({
    components: {
    },
    props: {
        pageData: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    computed: {
        isChoosed() {
            return this.pageData.feedbackInfo.readType !== 0;
        },
        choosedFeelRes() {
            return FEEL_MAP.filter(item => item.id === this.pageData.feedbackInfo.readType)[0];
        }
    },
    created() {
        // 缓存读取该报告的弹窗状态
        const {query} = this.$route;
        const {id = '1'} = query;
        const courseRecordId = window.localStorage.getItem(`courseRecordIdForFeel${id}`);

        console.log('加载读后感受');
        console.log('courseRecordId=', courseRecordId);
        console.log('Number(courseRecordId)=', Number(courseRecordId));
        console.log('Number(id)=', Number(id));
        console.log('!this.isChoosed=', !this.isChoosed);
        this.needShowDialog = Number(courseRecordId) !== Number(id) && !this.isChoosed;
        this.needShowDialog && (document.documentElement.style.overflow = 'hidden');
        console.log('this.needShowDialog=', this.needShowDialog);
        window.localStorage.setItem(`courseRecordIdForFeel${id}`, Number(id));
    }
})
export default class Feel extends Vue {
    feelData = FEEL_MAP;

    needShowDialog = false;

    // 关闭弹窗
    closeDialog() {
        this.needShowDialog = false;
        document.documentElement.style.overflow = 'scroll';
    }

    // 选择感受
    handleFeel(item) {
        // 播放选中的动效，时长是一秒
        item.choosing = true;
        setTimeout(async () => {
            item.choosing = false;
            const {uid, courseId, cTableId} = this.pageData;
            const res = await readFeedback({
                uid,
                courseId,
                cTableId,
                readType: item.id
            });
            if (res.code === '0') {
                this.$emit('updatePage');
            } else {
                this.$toast(res.msg);
            }
            this.needShowDialog && this.closeDialog();
        }, 1000);
    }
}
</script>

<style lang="scss" scoped>
.feel-box {
    width: 9.15rem;
    display: flex;
    justify-content: center;
    align-items: center;

    .shadow {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, .75);
        z-index: 3;
    }

    .feel-page {
        width: 9.15rem;
        height: 5.23rem;
        background: #FFFFFF;
        box-shadow: 0 .05rem .16rem 0 rgba(229, 228, 228, .4);
        border-radius: .43rem;
        padding: .61rem 0 .64rem;
        box-sizing: border-box;

        .feel-top {
            margin-left: .29rem;
            margin-bottom: .4rem;
            display: flex;
            align-items: center;

            .icon {
                width: .69rem;
                height: .69rem;
            }

            .title {
                font-size: .51rem;
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                color: #0B0B0B;
                margin: 0 .27rem 0 .08rem;
            }

            .desc {
                font-size: .37rem;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                color: #6A6A6A;
            }
        }

        .unselect-box {
            display: flex;
            justify-content: space-around;
            align-items: center;
            margin: 0 .53rem;

            .item {
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                width: 2.35rem;
                height: 2.88rem;
                background: #F8F8FA;
                border-radius: .29rem;

                .emotion-img {
                    width: 1.63rem;
                    height: 1.41rem;
                }

                .emotion-desc {
                    font-size: .4rem;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    color: #333333;
                }
            }
        }

        .select-box {
            width: 8.08rem;
            height: 2.88rem;
            background: #FFFCF1;
            border-radius: .29rem;
            margin: 0 .53rem;
            display: flex;
            justify-content: center;
            align-items: center;

            .emotion-img {
                width: 1.63rem;
                height: 1.41rem;
                margin-right: .77rem;
            }

            .right-content {
                text-align: center;

                .icon-top {
                    width: 2.27rem;
                    height: .53rem;
                }

                .emotion-content {
                    position: relative;
                    z-index: 1;
                    font-size: .4rem;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 600;
                    margin: -.2rem 0 .37rem;
                    text-align: center;
                }

                .emotion-content::after {
                    content: "";
                    display: block;
                    width: 1.71rem;
                    height: .32rem;
                    border-radius: .16rem;
                    position: absolute;
                    left: 50%;
                    transform: translateX(-50%);
                    bottom: -.1rem;
                    z-index: -1;
                }

                .happy {
                    color: #B54C1E;
                }

                .happy::after {
                    background: #FFD400;
                }

                .amazing {
                    color: #A62A16;
                }

                .amazing::after {
                    background: #FF825A;
                }

                .sad {
                    color: #6C1573;
                }

                .sad::after {
                    background: #D894F8;
                }

                .date {
                    font-size: .32rem;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    color: #CAA65D;
                }
            }
        }
    }

    .page {
        margin-top: .88rem;
    }

    .dialog {
        position: absolute;
        z-index: 4;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}
</style>
